module.exports = __webpack_public_path__ + "static/media/full-avatar.0ce9ac9e.jpeg";